import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const HeroContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #06b6d4 100%)',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
    zIndex: 1
  }
}));

const HeroContent = styled(Container)(({ theme }) => ({
  textAlign: 'center',
  zIndex: 2,
  position: 'relative',
  padding: '2rem 0'
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontSize: '4rem',
  fontWeight: 800,
  marginBottom: '1.5rem',
  textShadow: '0 4px 8px rgba(0,0,0,0.3)',
  letterSpacing: '-0.02em',
  lineHeight: 1.1,
  [theme.breakpoints.down('md')]: {
    fontSize: '3rem'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5rem'
  }
}));

const HeroSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  marginBottom: '3rem',
  opacity: 0.95,
  maxWidth: '700px',
  margin: '0 auto 3rem auto',
  fontWeight: 400,
  lineHeight: 1.6,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.25rem',
    marginBottom: '2rem'
  }
}));

const CTAButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'white',
  color: '#1e3a8a',
  padding: '16px 40px',
  fontSize: '1.2rem',
  fontWeight: 600,
  borderRadius: '12px',
  textTransform: 'none',
  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  '&:hover': {
    backgroundColor: '#f8fafc',
    transform: 'translateY(-3px)',
    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
  },
  transition: 'all 0.3s ease'
}));

const StatsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '3rem',
  marginTop: '4rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '2rem'
  }
}));

const StatItem = styled(Box)(({ theme }) => ({
  textAlign: 'center'
}));

const StatNumber = styled(Typography)(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 700,
  marginBottom: '0.5rem'
}));

const StatLabel = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  opacity: 0.8,
  fontWeight: 500
}));

const HeroSection = ({ businessName, description }) => {
  return (
    <HeroContainer>
      <HeroContent maxWidth="lg">
        <HeroTitle variant="h1">
          {businessName || 'Your Business Name'}
        </HeroTitle>
        <HeroSubtitle variant="h5">
          {description || 'Your business description goes here. Provide exceptional services and products tailored to your needs.'}
        </HeroSubtitle>
        <CTAButton variant="contained" size="large">
          Get Started Today
        </CTAButton>
        
        <StatsContainer>
          <StatItem>
            <StatNumber>500+</StatNumber>
            <StatLabel>Happy Clients</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>98%</StatNumber>
            <StatLabel>Success Rate</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>24/7</StatNumber>
            <StatLabel>Support</StatLabel>
          </StatItem>
        </StatsContainer>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
